import type { ClipboardEvent } from 'react';

let pastedImageId = 0;

export const pasteCommentImages = (
    event: ClipboardEvent<HTMLTextAreaElement>,
    addImages: (files: File[]) => void,
) => {
    const { clipboardData } = event;
    const itemFiles = Array.from(clipboardData.items)
        .filter(item => item.kind === 'file' && item.type.startsWith('image/'))
        .map(item => item.getAsFile())
        .filter((file): file is File => file !== null);
    const images = itemFiles.length ? itemFiles : Array.from(clipboardData.files)
        .filter(file => file.type.startsWith('image/'));

    if (!images.length) return;

    if (!clipboardData.getData('text/plain')) event.preventDefault();

    addImages(images.map(file => {
        const name = `clipboard-${Date.now()}-${++pastedImageId}-${file.name}`;
        return new File([file], name, { type: file.type, lastModified: file.lastModified });
    }));
};
import type { ClipboardEvent } from 'react';

let pastedImageId = 0;

export const pasteCommentImages = (
    event: ClipboardEvent<HTMLTextAreaElement>,
    addImages: (files: File[]) => void,
) => {
    const { clipboardData } = event;
    const itemFiles = Array.from(clipboardData.items)
        .filter(item => item.kind === 'file' && item.type.startsWith('image/'))
        .map(item => item.getAsFile())
        .filter((file): file is File => file !== null);
    const images = itemFiles.length ? itemFiles : Array.from(clipboardData.files)
        .filter(file => file.type.startsWith('image/'));

    if (!images.length) return;

    if (!clipboardData.getData('text/plain')) event.preventDefault();

    addImages(images.map(file => {
        const name = `clipboard-${Date.now()}-${++pastedImageId}-${file.name}`;
        return new File([file], name, { type: file.type, lastModified: file.lastModified });
    }));
};
